import { objectExtensions } from '@felicity/primitives';

import numbersBgBG from 'cldr-data/main/bg/numbers.json';
import numbersCsCZ from 'cldr-data/main/cs/numbers.json';
import numbersDaDK from 'cldr-data/main/da/numbers.json';
import numbersDeDE from 'cldr-data/main/de/numbers.json';
import numbersElGR from 'cldr-data/main/el/numbers.json';
import numbersEnGB from 'cldr-data/main/en-GB/numbers.json';
import numbersEsES from 'cldr-data/main/es/numbers.json';
import numbersEtEE from 'cldr-data/main/et/numbers.json';
import numbersFiFI from 'cldr-data/main/fi/numbers.json';
import numbersFrFR from 'cldr-data/main/fr/numbers.json';
import numbersGaIE from 'cldr-data/main/ga/numbers.json';
import numbersHrHR from 'cldr-data/main/hr/numbers.json';
import numbersHuHU from 'cldr-data/main/hu/numbers.json';
import numbersItIT from 'cldr-data/main/it/numbers.json';
import numbersLtLT from 'cldr-data/main/lt/numbers.json';
import numbersLvLV from 'cldr-data/main/lv/numbers.json';
// import numbersMtMT from 'cldr-data/main/mt/numbers.json';
import numbersNlNL from 'cldr-data/main/nl/numbers.json';
import numbersPlPL from 'cldr-data/main/pl/numbers.json';
import numbersPtPT from 'cldr-data/main/pt/numbers.json';
import numbersRoRO from 'cldr-data/main/ro/numbers.json';
import numbersSkSK from 'cldr-data/main/sk/numbers.json';
import numbersSlSI from 'cldr-data/main/sl/numbers.json';
import numbersSvSE from 'cldr-data/main/sv/numbers.json';

export default {
  main: {
    'bg-BG': numbersBgBG.main.bg,
    'cs-CZ': numbersCsCZ.main.cs,
    'da-DK': numbersDaDK.main.da,
    'de-DE': numbersDeDE.main.de,
    'el-GR': numbersElGR.main.el,
    'en-GB': numbersEnGB.main['en-GB'],
    'es-ES': numbersEsES.main.es,
    'et-EE': numbersEtEE.main.et,
    'fi-FI': numbersFiFI.main.fi,
    'fr-FR': numbersFrFR.main.fr,
    'ga-IE': numbersGaIE.main.ga,
    'hr-HR': numbersHrHR.main.hr,
    'hu-HU': numbersHuHU.main.hu,
    'it-IT': numbersItIT.main.it,
    'lt-LT': numbersLtLT.main.lt,
    'lv-LV': numbersLvLV.main.lv,
    // 'mt-MT': numbersMtMT.main.mt,
    'nl-NL': numbersNlNL.main.nl,
    'pl-PL': numbersPlPL.main.pl,
    'pt-PT': numbersPtPT.main.pt,
    'ro-RO': numbersRoRO.main.ro,
    'sk-SK': numbersSkSK.main.sk,
    'sl-SI': numbersSlSI.main.sl,
    'sv-SE': numbersSvSE.main.sv
  }
};
